import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getOperacaoByCPF } from "../../services/modules/cliente/operacaoService";
import { PageLoading } from "../../components/Loading/Loading";
import { Breadcrumbs } from "@mui/material";
import { StyledBreadcrumb } from "../../components/styled/breadcrumb";
import { StatusOperacao } from "../../models/modules/Cliente/Operacao";
import { PedidoResumo } from "../components/pedidoResumo";
import { useNavigate } from "react-router-dom";

export default function MeusPedidos() {
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);
  const [status, setStatus] = useState<StatusOperacao>(null);
  const [isQuitado, setIsQuitado] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    setLoad(true);
    getOperacaoByCPF(status)
      .then((resp) => {
        const dados = resp.dados;
        setData(dados)
        const moedas = dados.filter((item) => item.Quitado === "N");
        if(moedas.length > 1) setIsQuitado(false)


      })
      .catch((e) => e)
      .finally(() => setLoad(false));
  }, [status]);

  const onNavigate =  () => {
    const moedas = data.filter((item) => item.Quitado === "N");
    const resp = moedas.map((item) => item.Ope_ID);
    console.log(resp)
    navigate(`/om/servicos-cambio/moedas-estrangeiras/finalizar-pedido/pagamento/${resp.join(',')}`);
  }
  return (
    <>
      <MenuPrincipal>
        {load && <PageLoading />}
        <SectionContainer>
          <SectionIntroContainer>
            <h2 className="display-4">Meus Pedidos</h2>
          </SectionIntroContainer>
          <ContainerBreadCrumb role="presentation">
            <Breadcrumbs aria-label="breadcrumb">
              <StyledBreadcrumb
                component="a"
                href="#"
                label="Em aberto"
                data-value="Emaberto"
                onClick={() => setStatus("W")}
              />
              <StyledBreadcrumb
                component="a"
                href="#"
                label="Concluídos"
                data-value="Fin"
                onClick={() => setStatus("A")}
              />
              <StyledBreadcrumb
                component="a"
                href="#"
                label="Cancelados "
                data-value="Cancelados"
                onClick={() => setStatus("N")}
              />
            </Breadcrumbs>
          </ContainerBreadCrumb>

          {!isQuitado && <button onClick={onNavigate}>Realizar pagamentos</button>}
          {data &&
            data.map((item, i) => (
                <PedidoResumo item={item} button key={i}/>
            ))}
          {!load && data.length  === 0 && <SubTitle>Pedidos não encontrados</SubTitle>}
        </SectionContainer>
      </MenuPrincipal>
    </>
  );
}

const SubTitle = styled.h3`
margin: 40px 0;
text-align: center;
`

const ContainerBreadCrumb = styled.div`
  display: flex;
  justify-content: center;
`;
const MenuPrincipal = styled.div`
  background-color: #f7f7f7;
  padding-bottom: 20px;
`;

const SectionContainer = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 30px 15px;
`;

const SectionIntroContainer = styled.div`
  display: grid;
  place-items: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 700px;
  text-align: center;
  padding: 0 15px;

  h2 {
    text-transform: uppercase;
  }
`;
